import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=1afe1cfe&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=1afe1cfe&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1afe1cfe')) {
      api.createRecord('1afe1cfe', component.options)
    } else {
      api.reload('1afe1cfe', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=1afe1cfe&", function () {
      api.rerender('1afe1cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shifts/edit.vue"
export default component.exports